import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'includes',
})
export class IncludesPipe implements PipeTransform {
  transform(list: (string | number)[], item: string | number): boolean {
    return (list || []).includes(item);
  }
}
